import { render, staticRenderFns } from "./goPoints.vue?vue&type=template&id=13a3cdab"
import script from "./goPoints.vue?vue&type=script&lang=js"
export * from "./goPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports